export const PLAYBOOK_WIDGET_TOOL_NAME = "ui_widget_incident_add_playbook";

export const UI_LIST_TOOLS = [
  "ui_list_get_state",
  "ui_list_set_filter",
  "ui_list_search",
  "ui_list_clear_search",
  "ui_navigate",
  PLAYBOOK_WIDGET_TOOL_NAME,
  "ui_list_row_action",
];
